const downloadFile = (blob, filename, tab = null) => {
  const url = URL.createObjectURL(blob)

  if (tab) {
    tab.location.href = url
  } else {
    const a = document.createElement('a')
    a.href = url
    a.download = filename

    const onClick = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url)
        a.removeEventListener('click', onClick)
      }, 150)
    }

    a.addEventListener('click', onClick, false)
    a.click()
  }
}

const humanFileSize = (size: number) => {
  const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
  const fileSize = Number(size / Math.pow(1024, i))
  return fileSize.toFixed(1) + ['b', 'kb', 'mb', 'gb', 'tb'][i]
}

export { downloadFile, humanFileSize }
